import styles from './styles.less';
import { Link } from 'react-router-dom';
import React from 'react';

class Archive extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const archive = this.props.data;

        return (
            <div className={ this.props.className }>
                <div className={ styles.archiveHeader }></div>

                <div className={ styles.archiveContent }>
                    { Object.keys((archive)).map((seriesID, i) => {
                    const series = archive[seriesID];

                    if (!series.archiveThumbnail) return false;

                    return (
                        <div
                            key={ i }
                            className={ styles.series }>
                            <Link to={ '/comics/' + seriesID }>
                                <div className={ styles.image }>
                                    <img
                                        alt={ series.title }
                                        src={ series.archiveThumbnail }
                                    />
                                </div>

                                <h3>{ series.title }</h3>
                            </Link>

                            <p>
                                <a
                                    href={ series.artistSite }
                                    target="_blank">by { series.artist }
                                </a>
                            </p>

                        </div>
                    );
                }) }
                </div>
            </div>
        );

    }
}


export default Archive;



// WEBPACK FOOTER //
// ./src/client/components/archive/index.js